import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { GdprPage } from './-components/GdprPage';

const searchSchema = z.object({
  tab: z.enum(['expiring', 'pending', 'granted', 'withdrawn', 'all']).catch('expiring'),
  q: z.string().optional(),
  type: z.enum(['all', 'newsletter', 'marketing', 'research']).optional(),
  page: z.number().optional(),
  pageSize: z.number().optional(),
});

function GdprRoute() {
  useSetBreadcrumbs([{ label: 'Compliance' }, { label: 'GDPR' }]);
  return <GdprPage />;
}

export const Route = createFileRoute('/gdpr/')({
  validateSearch: searchSchema,
  component: GdprRoute,
  errorComponent: ErrorComponent,
});
